import { Box, Text, TextButton } from '@wix/design-system';
import { A11yCollapsibleCard, CollapseList, TaskListItem } from '@wix/rules-panel-ui';
import { StatusAlert } from '@wix/wix-ui-icons-common';
import React from 'react';
import { BiCtaNames } from '../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { useIsEditor3 } from '../../../../hooks/use-is-editor3';
import { useOpenArticleByEditorHost } from '../../../../hooks/use-open-article-by-editor-host';
import { WizardFooterManualTasks } from '../../../wizard-footer/wizard-footer-manual-tasks';
import { ManualTasksList } from '../manual-tasks';
export const ManualTasksCard = () => {
  const manualTasks = ManualTasksList();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const biLogger = useBiLogger();
  const {
    editorHost
  } = useA11yWizardAdapter();
  const isEditor3 = useIsEditor3();
  return /*#__PURE__*/React.createElement(A11yCollapsibleCard, {
    id: "manual-tasks",
    key: "manual-tasks",
    showBadge: false,
    title: "Manual tasks"
  }, /*#__PURE__*/React.createElement(CollapseList, {
    contentGap: 0
  }, manualTasks.map(task => /*#__PURE__*/React.createElement(TaskListItem, {
    id: task.title,
    key: task.title,
    prefix: /*#__PURE__*/React.createElement(Box, {
      height: "18px",
      verticalAlign: "middle",
      width: "18px"
    }, /*#__PURE__*/React.createElement(StatusAlert, null)),
    showBottomShadow: !isEditor3,
    showTopShadow: !isEditor3,
    title: task.title,
    variant: "collapsible"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    padding: "SP3 SP6 SP6"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, task.description), task.articleKey && /*#__PURE__*/React.createElement(TextButton, {
    ariaLabel: task.ariaLabel,
    paddingBottom: "SP1",
    size: "tiny",
    underline: "always",
    onClick: () => {
      biLogger.ctaClick({
        ctaName: `${BiCtaNames.ManualTask}-${task.ariaLabel}`
      });
      openSelectedArticle(editorHost, task.articleKey);
    }
  }, task.learnMore)))), /*#__PURE__*/React.createElement(WizardFooterManualTasks, {
    key: "wizard-footer-manual-tasks"
  })));
};
//# sourceMappingURL=manual-tasks-card.js.map